import { useState } from "react";
import allArtistComments from "../data/allArtistComments.json";
import "./comment.css";

const dayList = Object.keys(allArtistComments).reverse();

const DateSelector = ({
  selectedDay,
  setSelectedDay,
  toggleShowTime,
  setIsSearchOpen,
}) => {
  const [showAll, setShowAll] = useState(false);

  return (
    <div>
      <div
        style={{
          display: "flex",
          // height: "40px",
          alignItems: "flex-end",
          justifyContent: "space-between", // 왼쪽 끝 / 오른쪽 끝으로 벌림
          padding: "12px 16px 0px 16px",
        }}
      >
        <button
          style={{ border: "none", background: "none", fontSize: "20px" }}
          onClick={setIsSearchOpen}
        >
          🔎
        </button>

        {/* 오른쪽 버튼 2개 — gap으로 붙여서 그룹핑 */}
        <div style={{ display: "flex", gap: 4 }}>
          <button
            style={{ border: "none", background: "none" }}
            onClick={toggleShowTime}
          >
            <img
              src="https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/black-maintabIcoBrowse@2x.png"
              alt=""
              width={24}
            />
          </button>
          <button
            style={{ border: "none", background: "none" }}
            onClick={() => setShowAll(!showAll)}
          >
            <img
              src="https://pub-0cd71a413e214dd78d42cb52f2c1c8ba.r2.dev/images/maintabIcoBrowse@2x.png"
              alt=""
              width={30}
            />
          </button>
        </div>
      </div>

      {showAll && (
        <>
          <div
            onClick={() => setShowAll(false)} // 바깥 클릭하면 닫히게
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100dvh",
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              backdropFilter: "blur(2px)",
              zIndex: 999,
            }}
          />
          <div className="date-selector-popup">
            <div
              className="date-selector-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "18px",
                alignItems: "center",
                fontFamily: "KakaoBigFont",
              }}
            >
              <div style={{ fontSize: "18px", fontWeight: "600" }}>
                날짜 선택
              </div>
              <button
                className="date-selector-close-btn"
                onClick={() => {
                  setShowAll(false);
                }}
              >
                ×
              </button>
            </div>
            <div>
              {dayList.map((date) => (
                <div
                  key={date}
                  className="date-selector-item"
                  onClick={() => {
                    setSelectedDay(date);
                    setShowAll(false);
                  }}
                  style={{
                    backgroundColor: "#383d40",
                    filter:
                      date === selectedDay
                        ? "brightness(120%)"
                        : "brightness(100% ",
                    // backgroundColor:
                    //   date === selectedDay ? "#f8f9fb" : "transparent",
                    // display: "flex",
                    // justifyContent: "space-between",
                  }}
                >
                  {date === selectedDay ? <span>♥ </span> : <span>♡ </span>}
                  <span>{`${date.slice(0, 4)}.${date.slice(4, 6)}.${date.slice(
                    6,
                    8
                  )}`}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DateSelector;
